import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * PageLoader — état de chargement de page unifié (spinner doré discret + libellé),
 * en remplacement des « Chargement... » bruts éparpillés. Fini l'effet « page qui saute ».
 */
export default function PageLoader({ label = 'Chargement…', height = 'h-64' }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${height}`} data-testid="page-loader">
      <Loader2 className="w-5 h-5 animate-spin" style={{ color: '#C9A227' }} />
      <div className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>{label}</div>
    </div>
  );
}
